export const VECTOR_FILE_EXTENSIONS = new Set(['.svg', '.eps', '.pdf']);
export const IMAGE_FILE_EXTENSIONS = new Set(['.png', '.jpg', '.jpeg']);

export const getFilenameWithExtension = (path: string): string => {
    return path.replace(/^.*[\\/]/, '');
};

/**
 * Extract file extension from a path
 * @param path path to extract extension from
 * @returns file extension without the dot
 */
export const getExtension = (path: string): string => {
    const filename = getFilenameWithExtension(path);
    return /(?:\.([^.]+))?$/.exec(filename)?.[1] || '';
};

/**
 * Update/remove/add query parameter to the given URL
 * @param key query parameter name
 * @param value value for the query parameter
 * @param url url to alter
 */
export const updateQueryString = (key: string, value: string, url: string) => {
    if (!url) {
        return url;
    }

    const re = new RegExp('([?&])' + key + '=.*?(&|#|$)(.*)', 'gi');
    let hash;

    if (re.test(url)) {
        if (typeof value !== 'undefined' && value !== null) {
            return url.replace(re, '$1' + key + '=' + value + '$2$3');
        } else {
            hash = url.split('#');
            url = hash[0].replace(re, '$1$3').replace(/(&|\?)$/, '');
            if (typeof hash[1] !== 'undefined' && hash[1] !== null) {
                url += '#' + hash[1];
            }
            return url;
        }
    } else {
        if (typeof value !== 'undefined' && value !== null) {
            const separator = url.indexOf('?') !== -1 ? '&' : '?';
            hash = url.split('#');
            url = hash[0] + separator + key + '=' + value;
            if (typeof hash[1] !== 'undefined' && hash[1] !== null) {
                url += '#' + hash[1];
            }
            return url;
        } else {
            return url;
        }
    }
};

/**
 * Convert given path to a full CloudFront URL and add a query parameter to prevent cache responses between content loaded in DOM
 *  and content loaded in Javascript to prevent CORS issues.
 * @param path path to use to build the CloudFront URL
 * @param forDomLoad if true, the query parameter will indicate the URL will be used to load content from DOM
 *  instead of from Javascript, defaults to false.
 */
export const buildCloudFrontUrl = (path: string, forDomLoad = false): string => {
    if (!path) {
        return path;
    }

    // Remove /Content folder
    path = path.replace('/Content', '');
    if (path.startsWith('Content')) {
        path = path.replace('Content', '');
    }

    // Trim slashes
    const cdnUrl = process.env.VUE_APP_CLOUDFRONT_URL.replace(/^\/+|\/+$/g, '');
    path = encodeURI(path.replace(/^\/+|\/+$/g, ''));

    return updateQueryString('x-request', forDomLoad ? 'cl-core-html' : 'cl-core-js', `${cdnUrl}/${path}`);
};

export const getFilenameFromPath = (path: string): string => {
    return path.replace(/^.*[\\/]/, '');
};

export const getFilenameWithoutExtension = (filename: string): string => {
    return filename.replace(/\.[^.]+$/, '');
};
